import type { ResponseWithType } from './types';
import type { EventGallery } from '../../types';

const eventGallery = ({ data }: ResponseWithType<EventGallery>): EventGallery => {
  return data;
};

export default eventGallery;
